import * as React from 'react'
import { Form, Input, Button, Select, Row, Col, FormInstance } from 'antd'

interface PropsType {
    register: Function
    sendCaptcha: Function
    registerFailData: string
}

const Option = Select.Option;
const FormItem = Form.Item;

class RegisterForm extends React.Component<PropsType> {


    formRelf;
    constructor (props) {
        super(props);
        this.formRelf = React.createRef<FormInstance>();
    }

    state = {
        count: 0
    }

    onFinish = (values) => {
        console.log('Received values of form: ', values);
        this.props.register(values, true);
    }

    onFinishFailed = (errorInfo) => {
        console.log('error', errorInfo)
    }

    intId;
    onSendCaptcha = () => {
        let mobileNumber = this.formRelf.current.getFieldValue('mobileNumber') ;
        if(mobileNumber == '') {
            console.log('mobile none')
        }
        else {
            this.setState({
                count: 60
            });
            let that  = this;
            that.intId = setInterval(() => {
                let count = that.state.count;
                console.log(count);
                if(count === 0) {
                    window.clearInterval(that.intId)
                }
                else {
                    that.setState({
                        count: count - 1
                    });
                }
            }, 1000);
            this.props.sendCaptcha(mobileNumber, true);
        }
       
    }

    render() {

        let registerFailData = this.props.registerFailData;

        return (
            <Form 
                onFinish={this.onFinish} 
                onFinishFailed={this.onFinishFailed}
                className="login-form"
                ref={this.formRelf}
                >
                <FormItem 
                    name='mobileNumber' 
                    rules={[{ required: true, message: '请输入手机号', whitespace: true }]}
                    >
                    <Input 
                        size="large" 
                        addonBefore='+86'
                        placeholder="请输入手机号"
                        />
                </FormItem>
                <Row>
                    <Col span={14}> 
                        <FormItem 
                            name='captcha' 
                            rules={[{ required: true, message: '请输入验证码', whitespace: true }]}
                            >
                            <Input 
                                size="large" 
                                placeholder="请输入验证码" 
                                />
                        </FormItem>
                    </Col>
                    <Col span={10}>
                        {
                            this.state.count === 0 ?
                            <Button 
                                size="large"
                                className="btn_get_captcha" 
                                onClick={() => this.onSendCaptcha()}
                                >获取短信验证码</Button>
                            :
                            <Button 
                                disabled={true}
                                size="large"
                                className="btn_get_captcha" 
                                >{this.state.count}s</Button>
                        }
                    </Col>
                </Row>
                <FormItem 
                    name='password' 
                    rules={[{ required: true, message: '请输入密码', whitespace: true }]}
                    >
                    <Input.Password 
                        size="large" 
                        type="password" 
                        placeholder="请输入密码" 
                        />
                </FormItem>
                <FormItem>
                    <Button 
                        type="primary" 
                        size="large" 
                        htmlType="submit" 
                        className='btn_register_login'
                        >注册</Button>
                    {registerFailData && <p className="error">{registerFailData}</p>}
                </FormItem>
            </Form>
        );
    }
}
   
export default RegisterForm